export default {
  draftBox: '草稿箱',
  countrySite: '国家站',
  category: '品类',
  draftId: '草稿箱编号',
  latestModifiedDate: '最新修改日期',
  productName: '商品名称',
  pleaseSelect: '请选择',
  selectDate: '选择日期',
  reset: '重置',
  search: '搜索',
  operation: '操作',
  edit: '编辑',
  remove: '删除',
  basicSite: '基站',
  saveDraft: '保存为草稿'
}
